import apiClient from './client';

export interface AppNotificationDto {
  id: number;
  title: string;
  body: string;
  severity: string;
  actionUrl?: string | null;
  actionLabel?: string | null;
  sourceType: string;
  sourceKey: string;
  createdUtc: string;
  dismissedUntilUtc?: string | null;
}

export const notificationsApi = {
  getOpen: async (): Promise<AppNotificationDto[]> => {
    const response = await apiClient.get<AppNotificationDto[]>('/api/notifications/open');
    return response.data;
  },

  getPopup: async (): Promise<AppNotificationDto[]> => {
    const response = await apiClient.get<AppNotificationDto[]>('/api/notifications/popup');
    return response.data;
  },

  dismiss: async (id: number): Promise<AppNotificationDto> => {
    const response = await apiClient.post<AppNotificationDto>(`/api/notifications/${id}/dismiss`);
    return response.data;
  },
};
